import React from 'react';
import {Button, FormControl} from 'react-bootstrap'
import Parse from "parse";

export default class UserRow extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            user: props.user,
            name: props.user.name,
            email: props.user.email,
            phone: props.user.phone,
            aliases: props.user.aliases,
            editing: false,
        };
        this.edit = this.edit.bind(this);
        this.cancel = this.cancel.bind(this);
        this.delete = this.delete.bind(this);
        this.save = this.save.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        this.setState({[event.target.name]: event.target.value});
    }


    edit() {
        this.setState({editing: true});
    }
    cancel() {
        this.setState({
            editing: false,
            name: this.state.user.name,
            email: this.state.user.email,
            phone: this.state.user.phone,
            aliases: this.state.user.aliases,
        });
    }

    save() {
        let info = this.state.user.object;

        let aliases = this.state.aliases.toLowerCase().split(",").map(a => {return a.trim()});
        info.set("name", this.state.name);
        info.set("aliases", aliases);
        info.set("phone", this.state.phone);

        info.save().then(() => {
            let userObject = {
                object: info,
                name: this.state.name,
                aliases: aliases.join(", "),
                email: this.state.email,
                phone: this.state.phone,
            };
            this.setState({aliases: aliases.join(", "), editing: false, user: userObject});
        });
    }

    delete() {
        if (window.confirm("Delete user '" + this.state.email + "'?")) {

            console.log(this.state.user);
            let User = Parse.Object.extend("User");
            let user = new User();
            user.id = this.state.user.id;

            //Delete memberships
            let Membership = Parse.Object.extend("Membership");
            let promises = [];
            let roleQuery = new Parse.Query(Membership);
            roleQuery.equalTo("user", user);
            roleQuery.find(memberships => {
                for (let membership of memberships) {
                    promises.push(membership.destroy());
                }
            });


            //Set user as deleted
            Promise.all(promises).then(() => {
            let info = this.state.user.object;
            info.set("deleted", true);
            info.set("aliases", []);

            info.save().then(() => {
                window.location.reload(true);
            });
            })
        }
    }

    render() {
        return (
            this.state.editing ? (
            <tr>
                <th><FormControl type="text" name="name" value={this.state.name} onChange={this.handleChange} /></th>
                <th><FormControl type="text" name="aliases" value={this.state.aliases} onChange={this.handleChange} /></th>
                <th>{this.state.email}</th>
                <th><FormControl type="text" name="phone" value={this.state.phone} onChange={this.handleChange} /></th>
                <td>
                    <Button bsStyle="primary" bsSize="small" onClick={this.save}>
                        save
                    </Button> &nbsp;
                    <Button bsSize="small" onClick={this.cancel}>
                        cancel
                    </Button>
                </td>
            </tr>
            ) : (
                <tr>
                    <th>{this.state.name}</th>
                    <td>{this.state.aliases}</td>
                    <td>{this.state.email}</td>
                    <td>{this.state.phone}</td>
                    <td>
                        <Button bsSize="small" bsStyle="primary" onClick={this.delete}>
                            delete
                        </Button>{" "}
                        <Button bsSize="small" onClick={this.edit}>
                            edit
                        </Button>
                    </td>
                </tr>
            )
        );
    }

}


// WEBPACK FOOTER //
// ./src/userRow.js